module.exports = __webpack_public_path__ + "static/media/slide6.b35e4b21.jpg";